import {AdobeExperiencePlatformService} from "@app/core/tracking/infrastructure/adobe-experience-platform-service";
import {AdobeTrackingServiceCapacitorPlugin} from "@app/core/tracking/infrastructure/adobe-tracking-service-capacitor-plugin";
import {Injectable} from "@angular/core";

/**
 * Service responsible for communicating with Adobe Experience Platform (Adobe Campaign),
 * using the native SDK for Android and iOS.
 */
@Injectable()
export class NativeAdobeExperiencePlatformService implements AdobeExperiencePlatformService {
    trackAction(trackActionName: string): void {
        AdobeTrackingServiceCapacitorPlugin.trackAction({action: trackActionName});
    }
}